import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import useOnce from '@hooks/useOnce';
import Shimmer from '@shopDetails/components/Shimmer';
import Card from '@components/Card';
import { Simple } from '@components/ListItems';

const CardContainer = styled(Card)`
  padding: ${({ theme }) => theme.spacing(0, 6, 0, 0)};
`;

const StyledImageContainer = styled.div`
  padding-left: ${({ theme }) => theme.spacing(8)};
`;
function SectionsList({
  sectionsList,
  onShelveExpand,
  openAgeValidation,
  hasToValidateAge,
  fetchSectionsList,
  isFetching,
  show,
  trackSectionListShown,
}) {
  useOnce(() => {
    fetchSectionsList();
  });

  useEffect(() => {
    trackSectionListShown();
  }, [trackSectionListShown, show]);

  const sectionClick = useCallback(
    sec => {
      if (sec.requiresAgeCheck && hasToValidateAge) {
        openAgeValidation(sec);
      } else {
        onShelveExpand(sec);
      }
    },
    [hasToValidateAge, openAgeValidation, onShelveExpand],
  );

  if (!show) return null;

  if (isFetching && !sectionsList?.length) return <Shimmer />;

  if (sectionsList?.length) {
    return (
      <CardContainer direction="column" id="section-list-container">
        {sectionsList.map(sec => (
          <StyledImageContainer key={sec.id}>
            <Simple
              key={sec.id}
              label={sec.name}
              caption={`${sec.totalProducts} productos`}
              onClick={() => {
                sectionClick(sec);
              }}
              onContinue={() => {
                sectionClick(sec);
              }}
            />
          </StyledImageContainer>
        ))}
        {Boolean(isFetching) && <Shimmer />}
      </CardContainer>
    );
  }
}

SectionsList.propTypes = {
  sectionsList: PropTypes.array.isRequired,
  hasToValidateAge: PropTypes.bool.isRequired,
  onShelveExpand: PropTypes.func.isRequired,
  openAgeValidation: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,

  // redux
  isFetching: PropTypes.bool.isRequired,
  fetchSectionsList: PropTypes.func.isRequired,
  trackSectionListShown: PropTypes.func,
};

export default React.memo(SectionsList);
